import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** tailwind-merge that knows our extra font-size token (text-2xs), so it is not read as a colour. */
const merge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: ['2xs'] }] } },
});

/** Joins class names, letting later Tailwind classes override earlier ones (`cn(base, className)`). */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}

/** Focus ring for interactive elements, shown for keyboard focus only. */
export const focusRing =
  'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface';
